// Services
import { template } from "lodash";
import callAPI from "../callApi";
import path from "../variables";

const Templates = {
	getAll: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/templates${filter ? filter : ""}`,
			"",
			"getting all templates"
		),
	create: (data: any) =>
		callAPI("POST", `${path.base}/templates`, data, "creating new Templates"),
	update: (data: any, templateID: number) =>
		callAPI("PUT", `${path.base}/templates/${templateID}`, data, "updating Template"),
	delete: (data: any, templateID: number) =>
		callAPI("DEL", `${path.base}/templates/${templateID}`, data, "deleteing Template"),
};

export default Templates;
